import { render, staticRenderFns } from "./CancelPolicy.vue?vue&type=template&id=6e98b8b4&scoped=true"
import script from "./CancelPolicy.vue?vue&type=script&lang=js"
export * from "./CancelPolicy.vue?vue&type=script&lang=js"
import style0 from "./CancelPolicy.vue?vue&type=style&index=0&id=6e98b8b4&prod&lang=less&scoped=true"
import style1 from "./CancelPolicy.vue?vue&type=style&index=1&id=6e98b8b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e98b8b4",
  null
  
)

export default component.exports